import React, { FC } from 'react';
import ButtonComponent from '../../../Button.component';
import WarningIcon from '../../../Icons/Warning.icon';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

type CandidateUnmergeButtonProps = {
  isDisable: boolean;
  handleAction: (value: boolean) => void;
};

const StyledUnmergedButton = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const CandidateUnmergeButton: FC<CandidateUnmergeButtonProps> = ({
  isDisable,
  handleAction,
}) => {
  const { t } = useTranslation();

  return (
    <ButtonComponent
      disabled={isDisable}
      handleClick={() => handleAction(true)}
    >
      <StyledUnmergedButton>
        {isDisable && <WarningIcon />}
        <div>{t('Unmerge')}</div>
      </StyledUnmergedButton>
    </ButtonComponent>
  );
};

export default CandidateUnmergeButton;
